import {Injectable} from '@angular/core';
import { Ng2DeviceService } from 'ng2-device-detector';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import { config } from '../../providers/config';
import { Response } from '@angular/http';
import 'rxjs/add/operator/map';
import { Router, RouterModule, Routes } from '@angular/router';
import { HomeService } from '../services/home.service'
import { HttpService } from '../services/http.service';

@Injectable()
export class UtilService {
    userUrl = '/api/v1/users/';
    countriesUrl = '/api/v1/countries/'
    constructor(private deviceService: Ng2DeviceService,private http:HttpClient,private homeService:HomeService, private httpService:HttpService) { }
 
    getDeviceInfo() {
      let deviceInfo = this.deviceService.getDeviceInfo();
      return deviceInfo;
    }

    //Get logged in user details
    userDetails() {
      return this.httpService.get(this.homeService.getFullUrlWithUserId(this.userUrl,'/')).map((res:Response) => {
        return res.json();
      })
    }

    //Get countries
    getCountries() {
      return this.http.get(this.homeService.getFullUrl(this.countriesUrl),this.homeService.getHeader()).map((res:Response) => {
        return res;
      })
    }
}



// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/services/util.service.ts